import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import axios from 'axios';

import {
    initPointBalanceInfo,
    requestBigCardNumberStart,
    requestBigCardNumberSuccess,
    requestBigCardNumberFail,
    requestBigCardInfoStart,
    requestBigCardInfoSuccess,
    requestBigCardInfoFail,
    requestPointBalanceStart,
    requestPointBalanceSuccess,
    requestPointBalanceFail,
    requestPointExpireStart,
    requestPointExpireSuccess,
    requestPointExpireFail

} from '../actions/big-point';

import requestManagement from '../service/requestManagement';

const { method_POST, method_GET, method_GET_MULTIPLE_HEADER, method_POST_MULTIPLE_HEADER } = requestManagement;

import CONFIG, { jnzAuthConfig, bigCGateway, } from '@root/config/config.next';

const url = bigCGateway?.bigCGatewayEndpoint;

export function* requestBigPoint({ payload }) {

    const apiURL = `${bigCGateway?.bigCGatewayEndpoint}${bigCGateway?.pointBalance}`;
    // const apiURL = `${bigCGateway?.bigCGatewayEndpoint}/member-service/api/v2/pointExpire`;
    // console.log('[sages] requestBigPoint : ', { apiURL, payload, url, bigCGateway });

    //====================================================================================================================

    try {
        const data = yield method_POST_MULTIPLE_HEADER(
            {
                url: apiURL,
                data: payload.data,
                xApiKey: `Bearer ${bigCGateway?.bigCXApiKey}`
            }
        );

        // console.log("[API] POST : ", { data });

        if (data?.result)
            yield put(requestPointBalanceSuccess(data));
        else
            yield put(requestPointBalanceFail(data));

    } catch (error) {

        console.log("[Error] POST : ", { error });
        yield put(requestPointBalanceFail(error));
    }

    //====================================================================================================================

}

export function* requestPointExpire({ payload }) {

    const apiURL = `${bigCGateway?.bigCGatewayEndpoint}${bigCGateway?.pointExpire}`;
    // const apiURL = `${bigCGateway?.bigCGatewayEndpoint}member-service/api/v2/pointBalance`;

    console.log('[sages] requestPointExpire : ', { payload });

    //====================================================================================================================

    try {
        const data = yield method_POST_MULTIPLE_HEADER(
            {
                url: apiURL,
                data: payload.data,
                xApiKey: `Bearer ${bigCGateway?.bigCXApiKey}`
            }
        );

        // console.log("[API] POST : ", { data });

        if (data?.result)
            yield put(requestPointExpireSuccess(data));
        else
            yield put(requestPointExpireFail(data));

    } catch (error) {

        console.log("[Error] POST : ", { error });
        yield put(requestPointExpireFail(error));
    }

    //====================================================================================================================

}

//#region inactive =======================================================================================================

export function* requestBigCardNumber({ payload }) {

    /*console.log('[sages] postMasterBrand : ', payload);*/

    // const apiURL = `${bigCGateway?.bigCGatewayEndpoint}/backend/v1/brand`;
    const apiURL = `https://cloud-api.zeus.jenosize.dev/member/v1/provider/1066519b-a74e-4b2a-a288-eaf1aec44092`

    //====================================================================================================================

    try {
        const data = yield method_GET_MULTIPLE_HEADER({ url: apiURL, params: payload?.params, xApiKey: `Bearer ${bigCGateway?.bigCXApiKey}` });

        console.log("[API] GET : requestBigCardNumberStart ", data);

        yield put(requestBigCardNumberSuccess(data));

    } catch (error) {
        yield put(requestBigCardNumberFail(error));
    }

    //====================================================================================================================
}

//#endregion inactive ====================================================================================================

export function* requestBigCardInfo({ payload }) {

    // BIC_C_GATEWAY_ENDPOINT='https://gateway-api.cs-uat.bigc.jenosize.io'
    // BIC_C_GATEWAY_ENDPOINT='https://bgcdapi.bigc.co.th'

    const apiURL = `https://cloud-api.zeus.jenosize.dev/gateway-api/bigc/v1/adapter/bigcard`;

    // const apiURL = `${bigCGateway?.bigCGatewayEndpoint}/member-service/api/v2/pointExpire`;
    // console.log('[sages] requestBigPoint : ', { apiURL, payload, url, bigCGateway });

    //====================================================================================================================

    try {
        const data = yield method_POST_MULTIPLE_HEADER(
            {
                url: apiURL,
                data: payload.data,
                xApiKey: `Bearer ${bigCGateway?.bigCXApiKey}`
            }
        );

        // console.log("[API] POST : ", { data });

        if (data?.result)
            yield put(requestBigCardInfoSuccess(data));
        else
            yield put(requestBigCardInfoFail(data));

    } catch (error) {

        console.log("[Error] POST : ", { error });
        yield put(requestBigCardInfoFail(error));
    }

    //====================================================================================================================

}


export function* watchBigPiont() {

    // console.log('[sages] watchBigPiont : ✅');

    yield all([
        takeLatest(requestBigCardNumberStart, requestBigCardNumber),
        takeLatest(requestBigCardInfoStart, requestBigCardInfo),
        takeLatest(requestPointBalanceStart, requestBigPoint),
        takeLatest(requestPointExpireStart, requestPointExpire),
    ])
}



